export const RinseIcon = ({ color }: { color?: string }): JSX.Element => {
  color = color || '#0E00B3';

  return (
    <svg width="22" height="22" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.324 5.97656C2.436 5.98989 2.55066 5.99856 2.66666 5.99989C3.19333 6.00589 3.69266 5.88122 4 5.66656C4.30733 5.45322 4.80666 5.32856 5.33333 5.33322C5.86 5.32856 6.35933 5.45322 6.66666 5.66656C6.974 5.88122 7.47333 6.00589 8 5.99989C8.52666 6.00589 9.026 5.88122 9.33333 5.66656C9.64066 5.45322 10.14 5.32856 10.6667 5.33322C11.1933 5.32856 11.6927 5.45322 12 5.66656C12.3073 5.88122 12.8067 6.00589 13.3333 5.99989C13.4467 5.99989 13.5593 5.99056 13.6687 5.97722M2 4L3.14733 10.886C3.19925 11.1973 3.35993 11.4801 3.60078 11.6841C3.84164 11.8881 4.14704 12 4.46267 12H11.5373C11.853 12 12.1584 11.8881 12.3992 11.6841C12.6401 11.4801 12.8007 11.1973 12.8527 10.886L14 4M8 8.66699H8.00667M10 8.66699H10.0067M6 8.66699H6.00667"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
